import styled from 'styled-components';

export interface ButtonStyledProps {
  color?: string;
  textColor?: string;
  block?: boolean;
  size?: 'small' | 'medium' | 'large';
  shadow?: boolean;
  radius?: boolean;
}

export const ButtonStyled = styled.button<ButtonStyledProps>`
  background: ${props =>
    props.color
      ? props.theme.color[props.color] || props.color
      : props.theme.color.primary};

  color: ${props =>
    props.textColor
      ? props.theme.color[props.textColor] || props.textColor
      : '#fff'};

  ${props =>
    props.block &&
    `
    width: 100%;
    text-align: center;
  `}

  padding: .5rem 1rem;

  ${props =>
    props.size === 'medium' &&
    `
    padding: .75rem 1.25rem;
    font-size: 1.1rem;
  `}

  ${props =>
    props.size === 'large' &&
    `
    padding: 1rem 1.5rem;
    font-size: 1.2rem;
  `}

  ${props =>
    props.shadow &&
    `
    box-shadow: 0 0 20px rgba(0, 0, 0, .3);
  `}

  border: none;
  border-radius: ${props => props.theme.size.borderRadius};

  ${props =>
    props.radius &&
    `
    border-radius: 50%;
  `}
`;
